import { useState } from 'react'
import { useAuth } from './AuthProvider'
import { ProfileModal } from './ProfileModal'
import { BusinessCard } from './BusinessCard'
import { BottomSheet, SheetItem } from '@/shared/ui/BottomSheet'
import './MobileAccountSheet.css'

/**
 * The account menu, as a bottom sheet.
 *
 * Same contents as the avatar dropdown — who you are, edit profile, sign out —
 * in the shape a phone can actually hit. The dropdown is anchored to a 32px
 * circle in a header that does not exist below 760px, so this is a replacement
 * rather than a restyling.
 *
 * The role note comes along for the ride. It is the only place the interface
 * says out loud that a non-admin's settings are read-only, and dropping it on
 * mobile would leave the smaller screen as the one where you cannot find out
 * why a button is missing.
 */
export function MobileAccountSheet({ onClose }: { onClose: () => void }) {
  const { user, isAdmin, logOut } = useAuth()
  const [editing, setEditing] = useState(false)
  const [card, setCard] = useState(false)

  if (editing) return <ProfileModal onClose={onClose} />
  // The card replaces the sheet rather than stacking on it: it is full-screen,
  // and a sheet sliding out from under it would show through the rounded
  // corners.
  if (card) return <BusinessCard onClose={onClose} />

  return (
    <BottomSheet onClose={onClose}>
      <div className="acctsheet__head">
        {user?.photoUrl && <img className="acctsheet__photo" src={user.photoUrl} alt="" />}
        <div className="acctsheet__who">
          <div className="acctsheet__name">{user?.displayName || 'Signed in'}</div>
          <div className="acctsheet__email">{user?.email}</div>
          <div className="acctsheet__role">
            {isAdmin ? 'Admin' : 'Sales'} —{' '}
            {isAdmin
              ? 'can edit pipeline stages, templates and delete leads'
            : 'settings are read-only'}
          </div>
        </div>
      </div>

      <SheetItem label="Edit profile" onClick={() => setEditing(true)} />
      <SheetItem label="Digital business card" onClick={() => setCard(true)} />
      <SheetItem label="Sign out" danger onClick={() => void logOut()} />
    </BottomSheet>
  )
}
